import { createSlice } from "@reduxjs/toolkit";
import deactivateRadiologistUserApi from "@custom/rtk-apis/user/deactivateRadiologistUser";

const initialState = {
  status:"",
  result:{},
  message:"",
  loading:false,
  error:""
};

const deactivateRadiologistUserSlice = createSlice({
  name: "deactivateRadiologistUserSlice",
  initialState,
  reducers: {
    closeDeactivateRadiologistUserListModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    console.log("----------",builder)
    builder
      .addCase(deactivateRadiologistUserApi.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(deactivateRadiologistUserApi.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.message = payload.message;
      })
      .addCase(deactivateRadiologistUserApi.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export default deactivateRadiologistUserSlice.reducer;
export const { closeDeactivateRadiologistUserListModal } = deactivateRadiologistUserSlice.actions;
